import http from "../http-common";

class EmailDataService {
    sendMail(data) {
        return http.post("/mail", data);
    }

    sendMailDesvincular(data) {
        return http.post("/mail/desvincular", data);
    }
}

export default new EmailDataService();